import script from "./SelectPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SelectPanel.vue?vue&type=style&index=0&id=64f9ccca&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f9ccca"]])

export default __exports__